import { FPBand } from "../../lib/fpBands";

/** Accent color + soft background for a band. Mid-table (no colorVar) gets a neutral gray so every row still gets an accent, just a muted one. */
export function fpBandAccent(band: FPBand): { color: string; bg: string } {
  if (band.colorVar) return { color: `var(${band.colorVar})`, bg: `var(${band.colorVar}-bg)` };
  return { color: "var(--color-text-dim)", bg: "var(--color-surface-alt)" };
}

/** Small colored pill showing the band's name (admin-named or generic fallback). Rendered on every row — a stable per-row property, never conditionally mounted, so it's safe next to native drag-and-drop. */
export function FPBandPill({ band }: { band: FPBand }) {
  const { color, bg } = fpBandAccent(band);
  return (
    <span style={{
      fontSize: "0.68rem", fontWeight: 600, padding: "0.22rem 0.6rem", borderRadius: 999,
      color, background: bg, border: `1px solid ${color}`, whiteSpace: "nowrap", flexShrink: 0,
    }}>
      {band.label}
    </span>
  );
}
